import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { TmsWebBaseEditCreateService } from '../base';
import { PickingListLabel, SalesOrderStockAllocation, StockItemAllocation } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderStockAllocationService extends TmsWebBaseEditCreateService<
  SalesOrderStockAllocation,
  SalesOrderStockAllocation
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SalesOrderStockAllocation', $localize`Sales Order Stock Allocation`);
  }

  allocate(
    salesOrderLineId: string,
    stockItemId: string,
    hardAllocation: boolean,
    printPickingList: boolean,
  ): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/Allocate`, {
      salesOrderLineId,
      stockItemId,
      hardAllocation,
      printPickingList,
    });
  }

  swapStockAllocations(stockNo: string, selectedOrders: StockItemAllocation[]): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/SwapStockAllocations`, {
      stockNo,
      selectedOrders,
    });
  }

  updateSalesOrderStockAllocation(salesOrderStockAllocationId: string, quantity: number, focQuantity: boolean) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateSalesOrderStockAllocation`, {
      salesOrderStockAllocationId,
      quantity,
      focQuantity,
    });
  }

  updateHardAllocation(salesOrderStockAllocationId: string, hardAllocation: boolean) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateHardAllocation`, {
      salesOrderStockAllocationId,
      hardAllocation,
    });
  }

  getAllocations(salesOrderLineId: any, picking: boolean): Observable<SalesOrderStockAllocation[]> {
    return this.httpService.get<SalesOrderStockAllocation[]>(
      `${this.apiUrl}/GetAllocations?salesOrderLineId=${salesOrderLineId}&picking=${picking}`,
    );
  }

  getPickingListLabel(salesOrderStockAllocationId: any, previousLocation: boolean): Observable<PickingListLabel> {
    return this.httpService.get<PickingListLabel>(
      `${this.apiUrl}/GetPickingListLabel?salesOrderStockAllocationId=${salesOrderStockAllocationId}&previousLocation=${previousLocation}`,
    );
  }

  getPickingListLabelByDespatchNoteId(salesDespatchNoteId: string): Observable<PickingListLabel[]> {
    return this.httpService.get<PickingListLabel[]>(
      `${this.apiUrl}/GetPickingListLabelByDespatchNoteId?salesDespatchNoteId=${salesDespatchNoteId}`,
    );
  }

  pick(salesOrderStockAllocationId: string) {
    return this.httpService.post<PickingListLabel>(`${this.apiUrl}/Pick`, {
      salesOrderStockAllocationId,
    });
  }

  pickingMultiPiece(
    salesOrderLineId: string,
    stockItemIds: string[],
    stockRefs: string[],
    dimensions: string[],
    quantities: number[],
    grossWgt: number[],
    nettWgt: number[],
  ) {
    return this.httpService.post(`${this.apiUrl}/PickingMultiPiece`, {
      salesOrderLineId,
      stockItemIds,
      stockRefs,
      dimensions,
      quantities,
      grossWgt,
      nettWgt,
    });
  }

  saveAllocations(salesOrderLineId: string, selected: boolean[], stockItemIds: string[], quantities: number[]) {
    return this.httpService.post(`${this.apiUrl}/SaveAllocations`, {
      salesOrderLineId,
      selected,
      stockItemIds,
      quantities,
    });
  }

  multiPick(ids: string[]): Observable<SalesOrderStockAllocation[]> {
    return this.httpService.post<SalesOrderStockAllocation[]>(`${this.apiUrl}/MultiPick`, {
      ids,
    });
  }

  unpick(salesOrderStockAllocationId: string, mergeStock: boolean) {
    return this.httpService.post<any>(`${this.apiUrl}/Unpick`, {
      salesOrderStockAllocationId,
      mergeStock,
    });
  }

  updatePicked(salesOrderStockAllocationId: string, nettQuantity: number) {
    return this.httpService.post<PickingListLabel>(`${this.apiUrl}/UpdatePicked`, {
      salesOrderStockAllocationId,
      nettQuantity,
    });
  }

  pickDirectDespatchLine(salesOrderLineId: string, quantity: number): Observable<void> {
    return this.httpService.post<void>(`${this.apiUrl}/PickDirectDespatchLine`, {
      salesOrderLineId,
      quantity,
    });
  }

  pickDirectDespatchLines(lines: { salesOrderLineId: string; quantity: number }[]): Observable<string[]> {
    return this.httpService.post<string[]>(`${this.apiUrl}/PickDirectDespatchLines`, { lines });
  }
}
